import React from 'react';
import PropTypes from 'prop-types';
import { Text } from 'react-orange-ui';

import WordingService from '../../services/WordingService';
import Space from '../../orange-ui/components/Spaces/Space';

const Login = ({ login }) => {
  const caption = WordingService.getWording('caption', 'login');

  return (
    <>
      <Text size="s" id="orange-account">
        {caption}
        <b id="user-login">
          {login}
        </b>
      </Text>
      <Space size="l" />
    </>
  );
};

Login.propTypes = {
  /** String Orange account login state */
  login: PropTypes.string,
};

Login.defaultProps = {
  login: null,
};

export default Login;
